export const PLATFORM_LABELS: Record<string, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  youtube: "YouTube",
}

export const PLATFORM_COLOURS: Record<string, string> = {
  instagram: "bg-[#E1306C]",
  facebook: "bg-[#1877F2]",
  tiktok: "bg-charcoal",
  youtube: "bg-[#FF0000]",
}

export const POST_TYPE_LABELS: Record<string, string> = {
  reel: "Reel",
  post: "Post",
  short: "Short",
  video: "Video",
  listing: "Listing",
}

export const POST_KIND_STYLES: Record<string, { label: string; className: string }> = {
  video: { label: "Video", className: "bg-red/5 text-red border-red/20" },
  listing: { label: "Listing", className: "bg-charcoal/5 text-charcoal border-charcoal/15" },
  standalone: { label: "Post", className: "bg-stone/10 text-warm-grey border-stone/20" },
  standalone_video: { label: "Video post", className: "bg-red/5 text-red border-red/20" },
}

export const STATUS_STYLES: Record<string, { label: string; className: string }> = {
  pending: { label: "Pending", className: "bg-stone/10 text-warm-grey border-stone/20" },
  scheduled: { label: "Scheduled", className: "bg-charcoal/5 text-charcoal border-charcoal/15" },
  uploading: { label: "Uploading", className: "bg-stone/10 text-warm-grey border-stone/20" },
  published: { label: "Published", className: "bg-red/5 text-red border-red/20" },
  failed: { label: "Failed", className: "bg-charcoal/5 text-charcoal border-charcoal/15" },
}
